module.exports = __webpack_public_path__ + "static/media/loading-bar.de84ce51.gif";